import * as serverConfig from './server-config'
import * as commonUtil from './common-util'

let config = serverConfig.getConfig()

let getReferrerHost = function () {
	if (document.referrer && document.referrer.length > 0) {
		let split = document.referrer.split('/');
		if (split && split.length > 2) {
			return split[2]
		}
	}
	return ''
}

let getPromoCode = function () {
	return commonUtil.getUrlParameterByName('promoCode') || ''
}

let getInviterId = function () {
	return commonUtil.getUrlParameterByName('inviterId') || ''
}

let getChannel = function () {
	return commonUtil.getUrlParameterByName('channel') || ''
}

export let sa = require('root/sa-sdk-javascript/sensorsdata.min.js');

export function initSaAutoTrack() {
	sa.init({
		name: 'sa',
		show_log: !config.isProd,
		server_url: config.saServerUrl,
		web_url: config.saWebUrl,
		heatmap: {}
	});
	sa.quick('autoTrack');
}

export function trackPageVisit() {
	sa.track('GfBroker_Web_Page_Visit', {
		promoCode: getPromoCode(),
		inviterId: getInviterId(),
		channel: getChannel(),
		pageUrl: location.href,
		pageHost: location.host,
		pagePathname: location.pathname,
		referrerUrl: document.referrer,
		referrerHost: getReferrerHost()
	});
}

export function trackButtonClick(buttonId) {
	sa.track('GfBroker_Web_Button_Click', {
		promoCode: getPromoCode(),
		inviterId: getInviterId(),
		channel: getChannel(),
		buttonId: buttonId,
		pageUrl: location.href,
		pageHost: location.host,
		pagePathname: location.pathname,
		referrerUrl: document.referrer,
		referrerHost: getReferrerHost()
	});
}

export function trackDownload(platform) {
	sa.track('GfBroker_Web_Download', {
		platform: platform,
		promoCode: getPromoCode(),
		inviterId: getInviterId(),
		channel: getChannel(),
		pageUrl: location.href,
		pageHost: location.host,
		pagePathname: location.pathname,
		referrerUrl: document.referrer,
		referrerHost: getReferrerHost()
	});
}




// WEBPACK FOOTER //
// ./src/common/js/sa-service.js